import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { providePreventNumberInputScroll } from '@packages/ng-shared-ui';
import { AppComponent } from './app/app.component';
import { AppModule } from './app/app.module';

bootstrapApplication(AppComponent, {
  providers: [importProvidersFrom(AppModule), providePreventNumberInputScroll()],
})
  .catch(err => console.error(err));